import React from 'react'
import { Redirect } from 'react-router-dom'

class UserPurchasesRedirect extends React.PureComponent {
  render() {
    if (this.props.location && this.props.location.search) {
      const search = this.props.location.search.replace('?user=', '')
      return <Redirect to={{ pathname: `/purchases`, state: {user: search} }} />
    } else {
      return ''
    }
  }
}

export default UserPurchasesRedirect



// WEBPACK FOOTER //
// ./src/js/components/UserPurchasesRedirect.js